import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { authenticateWithBankID } from "../services/ApiService";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import boxmealLogoSrc from "../assets/images/logo.png";
import bankIdLogoSrc from "../assets/images/BankID_logo_white.png";
import splashImageSrc from "../assets/images/boxmart.jpg";

const OnboardingCustomScreen = () => {
    const navigate = useNavigate();
    const { token } = useAuth();

    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [buttonText, setButtonText] = useState("Logga in med BankID");

    useEffect(() => {
        if (token) {
            navigate("/products");
        }
    }, [navigate, token]);

    const handleButtonPress = async (e) => {
        e.preventDefault();
        setButtonDisabled(true);
        setButtonText("Behandlar...");

        try {
            const authResponse = await authenticateWithBankID();
            if (authResponse?.orderRef && authResponse?.autoStartToken) {
                sessionStorage.setItem("bankid_orderRef", authResponse.orderRef);
                sessionStorage.setItem("bankid_autoStartToken", authResponse.autoStartToken);
                navigate("/bankid-start");
            } else {
                setButtonDisabled(false);
                setButtonText("Logga in med BankID");
            }
        } catch (error) {
            setButtonDisabled(false);
            setButtonText("Logga in med BankID");
        }
    };

    return (
        <Container>
            <BackgroundImage src={splashImageSrc} alt="Splash" />
            <Content>
                <LogoTagline>
                    <TopLogo src={boxmealLogoSrc} alt="Logo" />
                    <Tagline>Handla smart – handla Boxmart</Tagline>
                </LogoTagline>

                <FlexSpacer />

                <InfoCard>
                    <CardTitle>Om Boxmart</CardTitle>
                    <CardText>
                        Boxmart gör det enkelt för föreningar att driva egna butiker och få en del av försäljningen!<br />
                        Ni säljer – vi sköter resten. Med färdiga lösningar för både fysisk butik och onlinehandel blir det lätt att komma igång och börja tjäna pengar till laget, klubben eller föreningen.
                    </CardText>
                    <ButtonsWrapper>
                        <LoginButton onClick={handleButtonPress} disabled={buttonDisabled}>
                            <BankIDLogo src={bankIdLogoSrc} alt="BankID" />
                            <span style={{ marginLeft: 10 }}>{buttonText}</span>
                        </LoginButton>
                        <AltButton href="https://boxmart.se/foreningar/" target="_blank" rel="noopener noreferrer">
                            Börja sälja med Boxmart
                        </AltButton>
                    </ButtonsWrapper>
                </InfoCard>
            </Content>
        </Container>
    );
};

export default OnboardingCustomScreen;


const Container = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`;

const BackgroundImage = styled.img`
  position: absolute;
  top: 0; left: 0; width: 100vw; height: 100vh;
  object-fit: cover;
  z-index: 1;
  pointer-events: none;
`;

const Content = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
`;

const LogoTagline = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;

  @media (max-height: 700px) {
    margin-top: 12px;
  }
`;

const TopLogo = styled.img`
  width: 220px;
  margin-bottom: 8px;
`;

const Tagline = styled.p`
  font-size: 22px;
  color: #000;
  text-align: center;
  margin-bottom: 0;
`;

const FlexSpacer = styled.div`
  flex: 1 1 auto;
  min-height: 8px;
`;

const InfoCard = styled.div`
  background-color: white;
  width: 100%;
  padding: 32px 20px;
  border-radius: 40px 40px 0 0;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-height: 600px) {
    padding: 18px 8px;
    border-radius: 24px 24px 0 0;
  }
`;

const CardText = styled.p`
  font-size: 16px;
  color: #333;
  text-align: center;
  margin-bottom: 24px;
  line-height: 1.6;
`;

const CardTitle = styled.p`
  font-size: 24px;
  color: #333;
  text-align: center;
  margin-bottom: 24px;
  line-height: 1.6;
`;

const ButtonsWrapper = styled.div`
  width: 100%;
  max-width: 350px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
`;

const LoginButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 24px;
  background-color: #b80000;
  border-radius: 100px;
  width: 100%;
  max-width: 350px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
  color: white;
  font-size: 18px;
  font-weight: bold;

  &:hover {
    background-color: #990000;
  }
`;

const AltButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 24px;
  border: 2px solid #b80000;
  border-radius: 100px;
  width: 100%;
  max-width: 350px;
  color: #b80000;
  font-size: 18px;
  font-weight: bold;
  text-decoration: none;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: rgba(184, 0, 0, 0.05);
  }
`;

const BankIDLogo = styled.img`
  width: 36px;
  height: 36px;
  margin-right: 12px;
`;